/**
 * minicart
 */

import Vue from 'vue/dist/vue';
import Page from 'js/lib/page';

import cartItem from '~/cart-item/cart-item';
import store, { eventBus } from 'js/lib/Store';

export default class MiniCart extends Page {
  init() {
    this.data = {
      isVisible: false,
      inProcess: false,
      price: 0,
      count: 1
    };

    this.elements();
    this.events({
      'click.minicart': {
        target: this.$.document,
        handler: e => this.handler(e)
      },
      'keydown.minicart': {
        target: this.$.window,
        handler: e => this.handler(e)
      }
    });

    this.vm = this.vue();
  }
  handler(e) {
    const methods = {
      click: this.click,
      keydown: this.keydown
    };

    const type = e.type;
    const method = methods[type];

    method.call(this, e);
  }
  click(e) {
    const $target = $(e.target);
    if (!$target.closest('.js-minicart').length) {
      this.vm.isVisible = false;
    }
  }
  keydown(e) {
    if (e.keyCode === 27) {
      this.vm.isVisible = false;
    }
  }
  vue() {
    const scope = this;

    return new Vue({
      el: this.$.root.get(0),
      data: this.data,
      computed: {
        amount() {
          return store.getters.productsAmount || 0;
        },
        products() {
          return store.state.products;
        },
        total() {
          return this.products.reduce((acc, product) => {
            return acc + Number(product.amount) * Number(product.price);
          }, 0);
        }
      },
      components: {
        'cart-item': cartItem
      },
      store,
      mounted() {
        eventBus.$on('product.add', () => {
          this.inProcess = true;
          setTimeout(() => {
            this.inProcess = false;
          }, 3000);
        });

        eventBus.$on('cart.notify', ({ amount }) => {
          this.count = amount;
        });
      }
    });
  }
}

Page.make(MiniCart, '.js-minicart');
